import { resolveUseClaimProjectionEngine } from '@shared';
import { CarePhase } from '@shared';
import {
  getPhaseInflationSchedule,
  PhaseInflationScheduleRow,
} from '@client/util/getPhaseInflationSchedule';

// With the claim-projection engine on, the phase inflation factor is the
// month-weighted AVERAGE of the phase's annually-stepped growth, so displays
// drop the year count and present the per-month schedule instead.
export function usePhaseInflationSchedule(
  client: Client,
  carePhase: CarePhase,
): { useMonthBasedGrowth: boolean; inflationSchedule: PhaseInflationScheduleRow[] } {
  // Braked off, the phase is priced by the closed form and its growth factor is
  // end-anchored, so a per-month schedule would not reconcile with the number
  // beside it. Callers fall back to the single-factor copy.
  const useMonthBasedGrowth = resolveUseClaimProjectionEngine(client);
  const inflationSchedule = useMonthBasedGrowth
    ? getPhaseInflationSchedule(client, carePhase)
    : [];
  return { useMonthBasedGrowth, inflationSchedule };
}
